<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.1633 23.1622C6.77369 22.3196 5 19.237 5 16.6166C5 13.5438 7.87072 11.2044 8.54075 10.0151C9.21078 8.82576 10.9384 5.21421 9.98589 1C9.98589 1 13.6119 3.88803 14.7221 6.76624C16.0359 10.1802 14.7484 13.8212 14.7484 13.8212C14.7484 13.8212 15.6942 13.912 16.4694 13.4327C17.2182 12.9669 17.7439 12.0808 17.7439 12.0808C17.7439 12.0808 19.6356 13.3935 19.4714 16.4324C19.34 19.0069 17.4284 22.2202 14.0323 23.1309C14.4133 22.6755 14.6959 22.0901 14.7813 21.4205C14.9915 19.7225 13.5265 18.9069 12.8827 17.5715C12.239 16.2355 13.047 14.5251 13.047 14.5251C11.7792 15.3573 9.10557 17.3726 9.07929 20.1496C9.06615 21.5224 9.54578 22.508 10.1633 23.1622Z"
    fill="currentColor"
  />
</template>
